import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";

// Post Slider Begin
const initImageCarousel = () => {
  // Get all postSliders components instances
  const sliders = document.querySelectorAll(".image-carousel-swiper");

  // Init slider and add events to each
  for (const slider of sliders) {
    const swiperControllers = slider.previousElementSibling;

    const swpPrev = swiperControllers.querySelector(".swiper-prev");
    const swpNext = swiperControllers.querySelector(".swiper-next");
    const ownPagination = swiperControllers.querySelector(".swiper-pagination");

    new Swiper(slider, {
      // configure Swiper to use modules
      modules: [Pagination, Navigation],
      loop: false,
      spaceBetween: 40,
      slidesPerView: 1,
      // If we need pagination
      pagination: {
        el: ownPagination,
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="' +
            currentClass +
            '"></span>' +
            " of " +
            '<span class="' +
            totalClass +
            '"></span>'
          );
        },
      },
      navigation: {
        prevEl: swpPrev,
        nextEl: swpNext,
      },
      breakpoints: {
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
      },
    });
  }
};
initImageCarousel();
// Post Slider Ends
